/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:01]
Permissions to update outside the main branch: [true]
*/

import { DropDown, ValidatedDropDownList, ValidatedInput } from '@finbeat/react-toolkit';
import { t } from 'i18next';
import { OutletFilter as OutletFilterType } from 'models/api/outlet';
import { SelectOption } from 'models/api/prop';
import { useMemo } from 'react';
import { Col, Row } from 'reactstrap';

export type OutletFilterProps = {
    tradeOrgs: SelectOption[];
    isTradeOrgsFetching: boolean;
    merchantRegions: DropDown[];
    typeWorks: DropDown[];
    isOutletDictsFetching: boolean;
};

const OutletFilter = (
    {
        tradeOrgs,
        isTradeOrgsFetching,
        merchantRegions,
        typeWorks,
        isOutletDictsFetching
    }: OutletFilterProps) => {
    const tradeOrgsDropDown = useMemo(
        () =>
            tradeOrgs.length
                ? tradeOrgs.map((x) => ({ id: x.value, name: x.text }))
                : [],
        [tradeOrgs]
    );

    return (
        <>
            <Row>
                <Col>
                    <ValidatedInput<OutletFilterType>
                        id="ot-id"
                        name="id"
                        label={t('BackOfficeId')}
                        type="number"
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedDropDownList<OutletFilterType>
                        name="region"
                        items={merchantRegions}
                        isLoading={isOutletDictsFetching}
                        disabled={!merchantRegions.length}
                        label={t('BackOfficeRegion')}
                    />
                </Col>
                <Col>
                    <ValidatedInput<OutletFilterType>
                        id="ot-address"
                        name="address"
                        label={t('BackOfficeAddress')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedDropDownList<OutletFilterType>
                        name="tradeOrgId"
                        items={tradeOrgsDropDown}
                        isLoading={isTradeOrgsFetching}
                        disabled={!tradeOrgs.length}
                        label={t('BackOfficeTradeOrg')}
                    />
                </Col>
            </Row>
            <Row>
                <Col xs="6">
                    <ValidatedDropDownList<OutletFilterType>
                        name="typeWork"
                        items={typeWorks}
                        isLoading={isOutletDictsFetching}
                        disabled={!typeWorks.length}
                        label={t('BackOfficeTypeWork')}
                    />
                </Col>
            </Row>
        </>
    );
};

export default OutletFilter;
